import { render, staticRenderFns } from "./RegistStageRainy.vue?vue&type=template&id=3f88d3e6&scoped=true&"
import script from "./RegistStageRainy.vue?vue&type=script&lang=js&"
export * from "./RegistStageRainy.vue?vue&type=script&lang=js&"
import style0 from "./RegistStageRainy.vue?vue&type=style&index=0&id=3f88d3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88d3e6",
  null
  
)

export default component.exports